import { render } from "./page-banners.vue?vue&type=template&id=49a6f663&scoped=true"
import script from "./page-banners.vue?vue&type=script&lang=js"
export * from "./page-banners.vue?vue&type=script&lang=js"

import "./page-banners.vue?vue&type=style&index=0&id=49a6f663&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49a6f663"

export default script